// extracted by css-extract-rspack-plugin
export default {"container":"ConfirmationCodeStep_container__MdKlm","cancelButtonWrapper":"ConfirmationCodeStep_cancelButtonWrapper__u3QZx"};